import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'

// state
const state = {
	filterData: {},
	formData: {
		request_status_id: '0',
		status_name: 'All',
		requester_id: '0',
		abbr_full_name: 'All',
	},
}

const getters = {

}


// mutations
const mutations = {
	RESET_FORM_DATA (state, {formData}){
		state.formData = formData
	},

	RESET_FILTER_DATA (state, {data}){
		state.filterData = data
	},

	REMOVE_KEY_FROM_FILTER_DATA(state, key){
		//console.log(key);
		delete state.filterData[key];
	},

	UPDATE_SELECTED_DATA(state, {formTab, key, value}){
		// append/update dataForServer
		if(key !== 'status_name' && key !== 'abbr_full_name'){
			// set filterData only when value exist, otherwise remove variable
			if(value != ''){
				state.filterData[key] = value;
			} else {
				delete state.filterData[key]
			}
		}

		// need to set formatData
		state.formData[key] = value;
	},
}

// actions
const actions = {
	updateSelectedData ({commit, state, dispatch}, {formTab, key, value}){
		commit('UPDATE_SELECTED_DATA', {formTab: formTab, key: key, value: value})
	},

	findRequests({commit, dispatch, state, getters, rootState, rootGetters}){
		// reload datatables
		var refreshTable = rootState.requests.tableRefresh;
		var table = `#${refreshTable}`;

		$(table).DataTable().ajax.reload();
	},

	removeKey({commit}, key){
		commit('REMOVE_KEY_FROM_FILTER_DATA', key);
	},

	setShowButton({commit}){

	},

	clear({commit, state, dispatch, getters, rootState, rootGetters}){
		var refreshTable = rootState.requests.tableRefresh;
		var table = `#${refreshTable}`;
		var formData = {
			request_status_id: '0',
			status_name: 'All',
			requester_id: '0',
			abbr_full_name: 'All',
		};

		var empty = {};

		commit('RESET_FORM_DATA', {formData: formData});
		commit('RESET_FILTER_DATA', {data: empty});
		// reload datatable to show all requestes
		$(table).DataTable().ajax.reload();
		
	},


}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}